import React, { useEffect, useState, useRef } from 'react';
import { NavHashLink } from 'react-router-hash-link';
import '../peakThrills.css';
import scrolldown from '../img/Arrow Down.png';
import insider1 from '../img/Peak Thrills/Blue-Pools_2 1.png';
import insider2 from '../img/Peak Thrills/Hiking-Trail_2 1.png';
import insider3 from '../img/Peak Thrills/Lakewanaka.co 2.png';
import arrow1 from '../img/Vector 2.png';
import arrow2 from '../img/Vector 1.png';
import arrow3 from '../img/Vector 6.png';
import arrow4 from '../img/Vector 3.png';
import bannerImg from '../img/Peak Thrills/W23_Cardrona_Trade_LowRes-50 1.jpeg';
import bannerImgMobile from '../img/Peak Thrills/W23_Cardrona_Trade_LowRes-50 1-Mobile.jpeg';
import activityBanner1 from '../img/Peak Thrills/(TNZ Visual Library) Cardrona Alpine Resort - Woman Ski  - highres credit destination queenstown-0003576 1.jpg';
import activityImg1 from '../img/Peak Thrills/(TNZ Newsroom) Franz Josef Heli Hike CREDIT FRANZ JOSEF GLACIER GUIDES 1.jpg';
import activityImg2 from '../img/Peak Thrills/TNZ Newsroom 1.jpg';
import activityImg3 from '../img/Peak Thrills/(TNZ Newsroom)IMG_1911 1.jpg';
import activityImg4 from '../img/Peak Thrills/(Tekapo Springs Website) tube-slideshow-1-f2480078 1.jpg';
import foodImg1 from '../img/Peak Thrills/Lean+Timms+Kamana+Queenstown+LR-14.jpg';
import foodImg2 from '../img/Peak Thrills/thumbnail_image1 1.jpg';
import foodImg3 from '../img/Peak Thrills/OSTERIA_OHAKUNE-6 1.jpg';
import foodImg4 from '../img/Peak Thrills/sightseeing-knoll-ridge-cafe-whakapapa-ski-area 1.jpg';
import bannerImg2 from '../img/Peak Thrills/(TNZ Newsroom)Views of The Pinnacles from inside Knoll Ridge Cafe1 1.jpg';
import LodgingCarousel from '../components/peak-thrills-lodging-carousel';
import mountain from '../img/image 1.png';
import booknow from '../img/Book Now Button.png';
import arrowRight from '../img/Arrow Right - transparent.png';
import arrowLeft from '../img/Arrow Left - transparent.png';

import activityImg1Mobile from '../img/Peak Thrills/mobile/(TNZ Newsroom) Franz Josef Heli Hike CREDIT FRANZ JOSEF GLACIER GUIDES 1.jpg';
import activityImg2Mobile from '../img/Peak Thrills/mobile/TNZ Newsroom 1.jpg';
import activityImg3Mobile from '../img/Peak Thrills/mobile/(TNZ Newsroom)IMG_1911 1.jpg';
import activityImg4Mobile from '../img/Peak Thrills/mobile/(Tekapo Springs Website) tube-slideshow-1-f2480078 1.jpg';
import foodImg1Mobile from '../img/Peak Thrills/mobile/Lean+Timms+Kamana+Queenstown+LR-14.jpg';
import foodImg2Mobile from '../img/Peak Thrills/mobile/thumbnail_image1 1.jpg';
import foodImg3Mobile from '../img/Peak Thrills/mobile/OSTERIA_OHAKUNE-6 2.jpg';
import foodImg4Mobile from '../img/Peak Thrills/mobile/sightseeing-knoll-ridge-cafe-whakapapa-ski-area 1.jpg';
import insider1Mobile from '../img/Peak Thrills/mobile/Blue-Pools_2.png';
import insider2Mobile from '../img/Peak Thrills/mobile/Hiking-Trail_2.png';
import insider3Mobile from '../img/Peak Thrills/mobile/Lakewanaka.co 2.jpeg';
import activityBanner1Mobile from '../img/Peak Thrills/mobile/(TNZ Visual Library) Cardrona Alpine Resort - Woman Ski  - highres credit destination queenstown-0003576 2.jpg';
import familyIcon from '../img/Family Friendly Icon.png';
import video from '../img/Peak Thrills/PT_Insiders Trip Review_Video_1_min.mp4';
import videoImg from '../img/Peak Thrills/Screenshot 2023-02-24 at 4.03 1.png'
import { useLocation } from 'react-router-dom';


const PeakThrills = ({ winterEscapeRef }) => {
    const [isPlaying, setIsPlaying] = useState(false);
    const togglePlay = () => {
        setIsPlaying(!isPlaying);
    };

    const location = useLocation()
    useEffect(() => {
        if (location.hash === "#review") {
            setTimeout(() => {
                ref4.current.scrollIntoView({ behavior: "smooth" });
            }, 500)
        }
    }, [location]);

    const ref1 = useRef(null);
    const ref2 = useRef(null);
    const ref3 = useRef(null);
    const ref4 = useRef(null);
    const ref5 = useRef(null);

    const handleClick = (ref) => (event) => {
        event.preventDefault();
        if (ref.current) {
            ref.current.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <>
            <div id="top" className="subPage-banner" ref={ref5}>
                <div className="banner-img desktop"><img src={bannerImg} alt="banner-img" /></div>
                <div className="banner-img mobile"><img src={bannerImgMobile} alt="banner-img-mobile" /></div>
                <div className="banner-header"><h1 data-aos="zoom-out">Peak Thrills</h1></div>
                <div className="btm-text">
                    <div className="name">Cardrona Alpine Resort</div>
                    <div className="copyright">©RealNZ</div>
                </div>
            </div>
            <div className="subMenu pt-4 pt-sm-0">
                <ul className="d-flex align-items-center justify-content-between">
                    <li><a href="#activities" onClick={handleClick(ref1)}>Activities</a></li>
                    <li><a href="#dining" onClick={handleClick(ref2)}>Dining</a></li>
                    <li><a href="#lodging" onClick={handleClick(ref3)}>Lodging</a></li>
                    <li><a href="#review" onClick={handleClick(ref4)}>The Ride Side's Review</a></li>
                </ul>
            </div>
            <div className="peakThrills-activities container section">
                <div className="anchor" id="activities" ref={ref1}></div>
                <div className="content"
                    data-aos="fade-up"
                >
                    <h2 className="violet">Activities</h2>
                    <h3 className="pt-sm-3 desktop">Conquer the slopes with an off-peak winter<br /> adventure that's truly e-peak!</h3>
                    <h3 className="mobile">Conquer the slopes with an <br />off-peak winter adventure <br />that's truly e-peak!</h3>
                    <p className="pt-sm-5 pt-4">Let Air New Zealand bring you an unforgettable winter with postcard views, epic ski fields and fun-filled slopes. Perfect for adrenaline experts and even little adventurers, New Zealand's off-peak travel season means there'll even be moments where you'll feel like the entire slope is all yours!</p>
                </div>
            </div>
            <div data-aos="fade-up">
                <div className="thumbnail-banner activities-thumbnail-banner mt-5 mb-0 mt-sm-5 mb-sm-5">
                    <img className="full-width desktop" src={activityBanner1} alt="activity-banner-1" />
                    <img className="full-width mobile" src={activityBanner1Mobile} alt="activity-banner-1" />
                </div>
                <div className="activity-body peakThrills second">
                    <div className="row">
                        <div className="col-sm-6 left-col p-left activity-body-col-1">
                            <div className="content pb-5 px-5 mx-sm-0">
                                <div className="d-flex align-items-center">
                                    <h3 className="desktop">Cardrona Alpine Resort,<br /><span className="violet">Cardrona</span></h3>
                                    <h3 className="mobile">Cardrona Alpine Resort, <span className="violet">Cardrona</span></h3>
                                    <div className="family-tooltip ms-4">
                                        <img className="family-icon" src={familyIcon} alt="family-icon" />
                                        <span className="tooltip-hover-text">
                                            Family-friendly
                                        </span>
                                    </div>
                                </div>
                                <p>Enjoy a family fun day out on the slopes, where even kids as young as 3 months can enjoy a snowy good time. Explore beginner-friendly slopes, join classes for different age groups, or take up private group lessons to learn together as a family.</p>
                                <p className="small-text light-italic location">Cardrona Valley Road, Cardrona 9305,<br /> New Zealand</p>
                            </div>
                            <div className="thumbnail-img pt-5 w-sm-5 pe-5 pe-sm-0">
                                <img className="full-width desktop" src={activityImg1} alt="activity-img-1" />
                                <img className="full-width mobile" src={activityImg1Mobile} alt="activity-img-1" />
                            </div>
                            <div className="content pt-3 pb-5 w-sm-5 pe-5 pe-sm-0">
                                <h3>Heli Hike, Franz <span className="violet">Josef</span></h3>
                                <p>A scenic helicopter ride over the glacier valley, followed by a guided ice hike that takes you through terrain like ice towers and caves that are always changing – no two hikes are alike.</p>
                                <p className="small-text light-italic location desktop">Glacier Base, 63 Cron Street, Franz Josef/ <br />Waiau 7886, New Zealand</p>
                                <p className="small-text light-italic location mobile">Glacier Base, 63 Cron Street, Franz Josef/ Waiau 7886, New Zealand</p>
                            </div>
                            <div className="content pt-5 ps-5 ps-sm-0" data-aos="zoom-out">
                                <div className="tip-box luggage">
                                    <p>
                                        <span className="weight-medium">Air New Zealand Travel Tip:</span><br />
                                        Bringing your own sports equipment?<br /> Air New Zealand's got you with a maximum allowed weight of 32kg and oversize length of 2.5m (98.4")!
                                    </p>
                                    <button><a href="https://www.airnewzealand.com.sg/oversized-items" target="_blank">Learn More</a></button>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 right-col p-left pt-5 mt-5 mt-sm-0 activity-body-col-2">
                            <div className="thumbnail-img pt-5 w-sm-5 ps-5 ps-sm-0">
                                <img className="full-width desktop" src={activityImg2} alt="activity-img-2" />
                                <img className="full-width mobile" src={activityImg2Mobile} alt="activity-img-2" />
                            </div>
                            <div className="content pt-3 w-sm-5 ps-5 ps-sm-0">
                                <h3>Snowmobiling, <span className="violet">Queenstown</span></h3>
                                <p>Trade your snowshoes for an adrenaline-fuelling snowmobile. Traverse the snowy backcountry for a fast-paced adventure through our winter wonderland.</p>
                                <p className="small-text light-italic location desktop">35 Lucas Place, Frankton, Queenstown 9300, <br />New Zealand</p>
                                <p className="small-text light-italic location mobile">35 Lucas Place, Frankton, Queenstown 9300, New Zealand</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="activity-body section">
                    <div className="row align-items-end">
                        <div className="col-sm-7 left-col pe-0 pe-sm-5 ps-0">
                            <div className="thumbnail-img pt-5">
                                <img className="full-width desktop" src={activityImg3} alt="activity-img-3" />
                                <img className="full-width mobile" src={activityImg3Mobile} alt="activity-img-3" />
                            </div>
                        </div>
                        <div className="col-sm-5 right-col ps-5 pe-5 pe-sm-0">
                            <div className="content">
                                <h3>Skydiving <span className="violet">Fox Glacier</span></h3>
                                <p>Get a literal bird's eye view of snowy peaks and glacial valleys with New Zealand's highest skydive at 20,000ft. Experience an epic freefall of over 85 seconds as you take in views of the Southern Alps.</p>
                                <p className="small-text light-italic location">Franz Josef Glacier Base, 69 Cron Street, Franz Josef / <br />Waiau 7886, New Zealand</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="activity-body peakThrills fourth pb-5">
                    <div className="row align-items-end activity-body-col-3 pb-5">
                        <div className="col-sm-6 left-col px-5">
                            <div className="content pt-3 m-right-0">
                                <div className="d-flex align-items-center">
                                    <h3>Snow Tubing, <span className="violet">Tekapo Springs</span></h3>
                                    <div className="family-tooltip ms-4">
                                        <img className="family-icon" src={familyIcon} alt="family-icon" />
                                        <span className="tooltip-hover-text">
                                            Family-friendly
                                        </span>
                                    </div>
                                </div>
                                <p>Enjoy an hour-long tubing session with thrilling rides down a 150m snowy slope, before being whisked back up to do it all over again. Incredibly fun for family and friends.</p>
                                <p className="small-text light-italic location">6 Lakeside Drive, Lake Tekapo 7999, <br />New Zealand</p>
                            </div>
                        </div>
                        <div className="col-sm-6 right-col p-right px-0">
                            <div className="thumbnail-img pt-5">
                                <img className="full-width desktop" src={activityImg4} alt="activity-img-4" />
                                <img className="full-width mobile" src={activityImg4Mobile} alt="activity-img-4" />
                                <div className="copyright">© Tekapo Springs</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="scroll-down text-center pt-5 mt-0 mt-sm-5" data-aos="zoom-out">
                <p className="violet"><span className="serif-bold">Next up,</span> Dining</p>
                <a href="#food" onClick={handleClick(ref2)} className="scroll-down-btn"><img src={scrolldown} alt="scroll-down" /></a>
            </div>
            <div className="section food purple-bg">
                <div className="anchor" id="dining" ref={ref2}></div>
                <div className="food-header text-center pb-5 px-5 px-sm-0" data-aos="fade-up">
                    <h2 className="violet">Dining</h2>
                    <h3 className="pt-4">Worked up an appetite on the slopes?<br />Refuel with delicious food, all locally sourced.</h3>
                    <p className="pt-4 pt-sm-5">Get a taste of New Zealand's seasonal dishes made with fresh ingredients from land and sea for the winter season.</p>
                    <p className="pt-4">Whether you're after warm, hearty meals to end off a day of hitting the slopes, or enjoying a coffee break in between, you'll be in for a treat any time of the day.</p>
                </div>
                <div className="food-body desktop" data-aos="fade-up">
                    <div className="row pt-5 pb-5">
                        <div className="col-sm-7 left-col pe-5">
                            <div className="thumbnail-img">
                                <img className="full-width" src={foodImg1} alt="food-img-1" />
                                <div className="copyright white">© Nest Kitchen & Bar</div>
                            </div>
                            <div className="content pt-3 pb-5">
                                <h3>Nest Kitchen & Bar, <span className="violet">Queenstown</span></h3>
                                <p>Unearth the rich flavours of our land and sea</p>
                                <p className="small-text light-italic location">139 Fernhill Road, Fernhill, Queenstown 9300, <br />New Zealand</p>
                            </div>
                            <div className="thumbnail-img pt-5">
                                <img className="full-width" src={foodImg3} alt="food-img-3" />
                                <div className="copyright">© Ohakune Osteria</div>
                            </div>
                            <div className="content pt-3">
                                <h3>Ohakune Osteria, <span className="violet">Ruapehu</span></h3>
                                <p>Loving recipes that transcend generations</p>
                                <p className="small-text light-italic location">75 Clyde Street, Ohakune 4625, <br />New Zealand</p>
                            </div>
                        </div>
                        <div className="col-sm-5 right-col ps-5">
                            <div className="thumbnail-img">
                                <img className="full-width" src={foodImg2} alt="food-img-2" />
                                <div className="copyright white">© Kika</div>
                            </div>
                            <div className="content pt-3 pb-5">
                                <h3>Kika, <span className="violet">Wanaka</span></h3>
                                <p>Fresh and sustainable regional produce</p>
                                <p className="small-text light-italic location">2 Dunmore Street, Wānaka 9305, <br />New Zealand</p>
                            </div>
                            <div className="thumbnail-img pt-5">
                                <img className="full-width" src={foodImg4} alt="food-img-4" />
                                <div className="copyright">© Love Taupo</div>
                            </div>
                            <div className="content pt-3">
                                <h3>Knoll Ridge Chalet, <span className="violet">Ruapehu</span></h3>
                                <p>Dine in the skies at New Zealand's highest restaurant</p>
                                <p className="small-text light-italic location">Whakapapa Ski Area, Top of Bruce Road, Mt Ruapehu, Tongariro National Park, <br />New Zealand 3951</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="food-body mobile" data-aos="fade-up">
                    <div className="row row-1 py-5 d-flex align-items-center">
                        <div className="col-6 pe-5 ps-0">
                            <div className="thumbnail-img">
                                <img className="full-width" src={foodImg1Mobile} alt="food-img-1" />
                                <div className="copyright white">© Nest Kitchen & Bar</div>
                            </div>
                        </div>
                        <div className="col-6 pe-5">
                            <div className="content">
                                <h3>Nest Kitchen & Bar, <span className="violet">Queenstown</span></h3>
                                <p>Unearth the rich flavours of our land and sea</p>
                                <p className="small-text light-italic location">139 Fernhill Road, Fernhill, Queenstown 9300, <br />New Zealand</p>
                            </div>
                        </div>
                    </div>
                    <div className="row row-2 py-5">
                        <div className="col-12 px-0">
                            <div className="thumbnail-img">
                                <img className="full-width" src={foodImg2Mobile} alt="food-img-2" />
                                <div className="copyright white">© Kika</div>
                            </div>
                        </div>
                        <div className="col-12 px-5">
                            <div className="content">
                                <h3>Kika, <span className="violet">Wanaka</span></h3>
                                <p>Fresh and sustainable regional produce</p>
                                <p className="small-text light-italic location">2 Dunmore Street, Wānaka 9305, <br />New Zealand</p>
                            </div>
                        </div>
                    </div>
                    <div className="row row-3 d-flex align-items-center py-5">
                        <div className="col-6 ps-5">
                            <div className="content">
                                <h3>Knoll Ridge Chalet, <span className="violet">Ruapehu</span></h3>
                                <p>Dine in the skies at New Zealand's highest restaurant</p>
                                <p className="small-text light-italic location">Whakapapa Ski Area, Top of Bruce Road, Mt Ruapehu, Tongariro National Park, <br />New Zealand 3951</p>
                            </div>
                        </div>
                        <div className="col-6 ps-5 pe-0">
                            <div className="thumbnail-img">
                                <img className="full-width" src={foodImg4Mobile} alt="food-img-3" />
                                <div className="copyright">© Love Taupo</div>
                            </div>
                        </div>
                    </div>
                    <div className="row row-4 py-5">
                        <div className="col-12 px-0">
                            <div className="thumbnail-img">
                                <img className="full-width" src={foodImg3Mobile} alt="food-img-4" />
                                <div className="copyright">© Ohakune Osteria</div>
                            </div>
                        </div>
                        <div className="col-12 px-5">
                            <div className="content">
                                <h3>Ohakune Osteria, <span className="violet">Ruapehu</span></h3>
                                <p>Loving recipes that transcend generations</p>
                                <p className="small-text light-italic location">75 Clyde Street, Ohakune 4625, <br />New Zealand</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="banner thumbnail-banner purple-bg pt-5 pt-sm-0">
                <img className="full-width desktop" src={bannerImg2} alt="banner-img-2" />
                <div className="name white desktop">Knoll Ridge Chalet</div>
                <div className="scroll-down text-center pt-5 mt-5 absolute" data-aos="zoom-out">
                    <p className="white black-mobile"><span className="serif-bold">Next up,</span> Lodging</p>
                    <a href="#lodging" onClick={handleClick(ref3)} className="scroll-down-btn"><img src={scrolldown} alt="scroll-down" /></a>
                </div>
            </div>
            <div className="section lodging" data-aos="fade-up">
                <div className="anchor" id="lodging" ref={ref3}></div>
                <div className="row">
                    <div className="col-sm-4 col-12 p-left pt-0 pt-sm-5 pe-5 pe-sm-0 ps-5">
                        <h2 className="violet">Lodging</h2>
                        <div className="header lodging">
                            <h3 className="pt-3 desktop">Stay at the heart of <br />the action.</h3>
                            <h3 className="pt-3 mobile">Stay at the heart of the action.</h3>
                            <p className="pt-3">Ever stayed on top of a mountain? Explore unique and exciting accommodations while enjoying off-peak prices during the winter months – perfect for all budgets and preferences.</p>
                        </div>
                    </div>
                    <div className="col-sm-8 col-sm-12 p-left">
                        <LodgingCarousel />
                    </div>
                </div>
            </div>
            <div className="scroll-down text-center pt-0 pt-sm-5 mt-0 mt-sm-5" data-aos="zoom-out">
                <p className="violet"><span className="serif-bold">Next up,</span> Insider's Trip Review</p>
                <a href="#review" onClick={handleClick(ref4)} class="scroll-down-btn"><img src={scrolldown} alt="scroll-down" /></a>
            </div>

            <div id="review" ref={ref4}>
                <div className="section purple-bg subPage-reviews desktop">
                    {/* <div className="anchor" id="review" ref={ref4}></div> */}
                    <div data-aos="fade-up">
                        <h2 className="text-center violet py-5">Insider's Trip Review:</h2>
                        <div className="row pt-5">
                            <div className="col-sm-6 p-right-half">
                                <div className="content m-right-0">
                                    <h3>The Ride Side (@therideside)</h3>
                                    <p>Conquer the slopes of New Zealand with The Ride Side, Singapore's very own snowboarding company. Get a peek at their adrenaline-fuelled adventures and discover their picks to inspire your own thrilling trip.</p>
                                </div>
                            </div>
                            <div className="col-sm-6 p-left-half">
                                <div className="tip-box insider">
                                    <p>
                                        <span className="weight-medium">The Ride Side's Trip Tip:</span><br />
                                        Rent a car for more flexibility as the bus takes a while to get up the mountain, picking so many people up!
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="row section px-sm-4 mt-5">
                            <div className="col-sm-7 ps-sm-0 left-col pe-5 p-left">
                                <div className="thumbnail-img video">
                                    <img className="full-width" src={videoImg} alt="activity-img=3" onClick={togglePlay} />
                                    {isPlaying && (
                                        <video control controls={true} autoPlay={true} muted={true}>
                                            <source src={video} type="video/mp4" />
                                        </video>
                                    )}
                                </div>
                            </div>
                            <div className="col-sm-5 right-col">
                                <div className="content pt-3">
                                    <h3 className="number violet">1</h3>
                                    <h3>Snowboard, ski and stay in <span className="violet">Wanaka</span></h3>
                                    <p className="pt-3">Cardrona has the best facilities for beginners and advanced riders alike, while Treble Cone's Saddle Basin is a powder day must-go!</p>
                                    <p className="pt-3">Just an hour away, The Remarkables has a great natural freestyle park with natural logs, concrete boxes and even rooftops, while Coronet Peak's night skiing is a sight to see for party goers - with apres ski in full swing and sometimes, the occasional DJ set end the day on the mountains.</p>
                                </div>
                            </div>
                        </div>
                        <div className="insider-overlap-section peak-thrills">
                            <div className="z-index-3 overlapping-row d-flex flex-wrap">
                                <div className="w-4"></div>
                                <div className="w-6">
                                    <div className="top d-flex">
                                        <div className="images w-6">
                                            <img className="thumbnail-img" src={insider1} alt="insider-1" />
                                            <img className="thumbnail-arrow desktop" data-aos="fade-in" src={arrow1} alt="arrow-1" />
                                            <img className="thumbnail-arrow mobile" src={arrow4} alt="arrow-4" />
                                            <div className="content mobile">
                                                <h3 className="number violet">2</h3>
                                                <h3>Blue Pools, <span className="violet">Makarora</span> </h3>
                                                <p className="pt-3">Enjoy winter activities off the mountain, like a road trip to Makarora for the Blue Pools.</p>
                                            </div>
                                        </div>
                                        <div className="content w-4 pb-5 ps-5">
                                            <h4 data-aos="fade-in" data-aos-delay="400">“Dive into the pristine waters of Makarora River's Blue Pools, if you're up for it.”</h4>
                                        </div>
                                    </div>
                                    <div className="bottom">
                                        <div className="content">
                                            <h3 className="number violet">2</h3>
                                            <h3>Blue Pools, <span className="violet">Makarora</span> </h3>
                                            <p className="pt-3">Enjoy winter activities off the mountain, like a road trip to Makarora for the Blue Pools.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="z-index-1 overlapping-row">
                                <div className="top d-flex align-items-end">
                                    <div className="content w-4 pe-5">
                                        <h4 data-aos="fade-in">“Hike up <br />Roy's Peak for astounding views of Lake Wanaka.”</h4>
                                    </div>
                                    <div className="images w-6">
                                        <div className='thumbnail-img-container'>
                                            <img className="thumbnail-img" src={insider2} alt="insider-2" />
                                        </div>
                                        <img className="thumbnail-arrow desktop" data-aos="fade-in" src={arrow2} alt="arrow-2" />
                                        <img className="thumbnail-arrow mobile" src={arrow4} alt="arrow-4" />
                                    </div>
                                </div>
                                <div className="bottom">
                                    <div className="content w-4">
                                        <h3 className="number violet">3</h3>
                                        <h3>Hiking Trails, <span className="violet">Wanaka</span> </h3>
                                        <p className="pt-3">Amazing hiking trails suitable for beginners, with short hikes to Mount Iron & Diamond Lake.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="z-index-2 overlapping-row d-flex">
                                <div className="w-45"></div>
                                <div className="w-55">
                                    <div className="top d-flex align-items-end">
                                        <div className="images col-sm-12">
                                            <img className="thumbnail-img" src={insider3} alt="insider-3" />
                                            <img className="thumbnail-arrow desktop" data-aos="fade-in" src={arrow3} alt="arrow-3" />
                                            <img className="thumbnail-arrow mobile" src={arrow1} alt="arrow-1" />
                                        </div>
                                    </div>
                                    <div className="bottom d-flex align-items-center">
                                        <div className="content w-5">
                                            <h3 className="number violet">4</h3>
                                            <h3>Red Star Burger, <span className="violet">Wanaka</span> </h3>
                                            <p className="pt-3">This town favourite is one of Wanaka's many amazing hidden gems showcasing local produce.</p>
                                        </div>
                                        <div className="content w-5 ps-5">
                                            <h4 data-aos="fade-in">“Might be even better than Queenstown's Ferg's without the queue.”</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="section purple-bg subPage-reviews mobile">
                    {/* <div className="anchor" id="review"></div> */}
                    <div data-aos="fade-up">
                        <h2 className="text-center violet pt-5">Insider's Trip Review:</h2>
                        <div className="row pt-0 px-5 text-center">
                            <div className="col-sm-6">
                                <div className="content m-right-0">
                                    <h3>The Ride Side (@therideside)</h3>
                                    <p>Conquer the slopes of New Zealand with The Ride Side, Singapore's very own snowboarding company. Get a peek at their adrenaline-fuelled adventures and discover their picks to inspire your own thrilling trip.</p>
                                </div>
                            </div>
                            <div className="col-sm-6 pt-5">
                                <div className="tip-box insider">
                                    <p>
                                        <span className="weight-medium">The Ride Side's Trip Tip:</span><br />
                                        Rent a car for more flexibility as the bus takes a while to get up the mountain, picking so many people up!
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="row section insider-top-row peak">
                            <div className="col-12 px-0 pt-5">
                                <div className="thumbnail-img video">
                                    <img className="full-width" src={videoImg} alt="activity-img=3" onClick={togglePlay} />
                                    {isPlaying && (
                                        <video control controls={true} autoPlay={true} muted={true}>
                                            <source src={video} type="video/mp4" />
                                        </video>
                                    )}
                                </div>
                            </div>
                            <div className="col-12 px-5">
                                <div className="content pt-3">
                                    <h3 className="number violet">1</h3>
                                    <h3>Snowboard, ski and stay in <span className="violet">Wanaka</span></h3>
                                    <p className="pt-3">Cardrona has the best facilities for beginners and advanced riders alike, while Treble Cone's Saddle Basin is a powder day must-go!</p>
                                    <p className="pt-3">Just an hour away, The Remarkables has a great natural freestyle park with natural logs, concrete boxes and even rooftops, while Coronet Peak's night skiing is a sight to see for party goers - with apres ski in full swing and sometimes, the occasional DJ set end the day on the mountains.</p>
                                </div>
                            </div>
                        </div>
                        <div className="insider-sub-section peak">
                            <div className="row row-1">
                                <div className="col-12 px-0 relative">
                                    <img className="thumbnail-img full-width" src={insider1Mobile} alt="insider-1" />
                                    <img className="thumbnail-arrow" src={arrow3} alt="arrow-4" />
                                </div>
                            </div>
                            <div className="row align-items-center row-1-content">
                                <div className="col-6 ps-5 pe-2">
                                    <div className="content">
                                        <h3 className="number violet">2</h3>
                                        <h3>Blue Pools, <span className="violet">Makarora</span> </h3>
                                        <p className="">Enjoy winter activities off the mountain, like a road trip to Makarora for the Blue Pools.</p>
                                    </div>
                                </div>
                                <div className="col-6 ps-5 pe-5">
                                    <div className="content right">
                                        <h4>“Dive into the pristine waters of Makarora River's Blue Pools, if you're up for it.”</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="row row-2 pt-5 align-items-end pb-5 ">
                                <div className="col-6 ps-5 pe-2">
                                    <div className="content top">
                                        <h4>“Hike up <br />Roy's Peak for astounding views of Lake Wanaka.”</h4>
                                    </div>
                                    <div className="content w-4">
                                        <h3 className="number violet">3</h3>
                                        <h3>Hiking Trails, <br /><span className="violet">Wanaka</span> </h3>
                                        <p className="">Amazing hiking trails suitable for beginners, with short hikes to Mount Iron & Diamond Lake.</p>
                                    </div>
                                </div>
                                <div className="col-6 ps-2 pe-0 relative">
                                    <img className="thumbnail-img full-width" src={insider2Mobile} alt="insider-1" />
                                    <img className="thumbnail-arrow" src={arrow4} alt="arrow-4" />
                                </div>
                            </div>
                            <div className="row row-3 align-items-center pt-5">
                                <div className="col-12 px-0 relative">
                                    <img className="thumbnail-img full-width" src={insider3Mobile} alt="insider-1" />
                                    <img className="thumbnail-arrow" src={arrow3} alt="arrow-4" />
                                </div>
                                <div className="col-6 ps-5 pe-4">
                                    <div className="content left">
                                        <h4>“Might be even better than Queenstown's Ferg's without the queue.”</h4>
                                    </div>
                                </div>
                                <div className="col-6 ps-3 pe-5">
                                    <div className="content w-4">
                                        <h3 className="number violet">4</h3>
                                        <h3>Red Star Burger Bar, <span className="violet">Wanaka</span> </h3>
                                        <p className="">This town favourite is one of Wanaka's many amazing hidden gems showcasing local produce.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="purple-bg mountainImg">
                <img className="full-width" src={mountain} alt="mountain" />
            </div>
            <div className="footer-CTA text-center px-5" data-aos="fade-up">
                <h2 className="pb-4">Ready for your winter escape?</h2>
                <a ref={winterEscapeRef} href="https://flightbookings.airnewzealand.com.sg/vbook/actions/ext-search" target="_blank" id="winter-escape-cta"><img className="bookNow-btn" src={booknow} alt="booknow" /></a>
            </div>
            <div className="newsletter purple-bg section text-center">
                <p className="violet weight-medium">Get the latest flight deals and travel tips</p>
                <h2 className="pb-4">Join our newsletter</h2>
                <button><a href="https://www.airnewzealand.com.sg/email-offer-signup" target="_blank">Sign Up</a></button>
            </div>
            <div className="services-page purple-bg">
                <div className="row d-flex flex-wrap">
                    <div className="col-6 services-pagination-col wonders d-flex flex-wrap align-items-center justify-content-start">
                        <NavHashLink to='/wonders-in-the-wild'><img className="prevArrow me-3" src={arrowLeft} alt="arrow-left" /></NavHashLink>
                        <NavHashLink to='/wonders-in-the-wild'><h2>Wonders in the Wild</h2></NavHashLink>
                    </div>
                    <div className="col-6 text-right services-pagination-col chillOut d-flex flex-wrap align-items-center justify-content-end">
                        <NavHashLink to='/chill-out-and-about'><h2>Chill Out and About</h2></NavHashLink>
                        <NavHashLink to='/chill-out-and-about'><img className="nextArrow ms-3" src={arrowRight} alt="arrow-right" /></NavHashLink>
                    </div>
                    <div className="scroll-down text-center absolute">
                        <p>Back to the top</p>
                        <a href="#top" onClick={handleClick(ref5)}><img src={scrolldown} alt="scroll-down" /></a>
                    </div>
                </div>
            </div>
        </>
    );
};
export default PeakThrills;
